import React, { useEffect } from 'react';
import { SearchClient } from 'instantsearch.js';
import { Configure, InstantSearch } from 'react-instantsearch';

import { useSearchListContext } from '../context/SearchListProvider';
import SearchListResults from './SearchListResults';
import SearchInput from './SearchInput';

export type SearchListProps = {
  searchClient: SearchClient;
  indexName?: string;
};

const SearchList = ({
  searchClient,
  indexName = 'dgfp_shared_index'
}: SearchListProps) => {
  const { search, hideResults } = useSearchListContext();

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={indexName}
      routing={true}
      onStateChange={(helper) => {
        if (search.resultsHidden) {
          hideResults(!helper.uiState[indexName].query);
        }
        helper.setUiState(helper.uiState);
      }}
    >
      <Configure analytics={false} filters={search.filters} />
      <SearchInput />
      <SearchListResults />
    </InstantSearch>
  );
};

export default SearchList;
